import { Component, OnInit, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-layout-grafico',
  templateUrl: './modal-layout-grafico.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-layout-grafico.component.css']
})
export class ModalLayoutGraficoComponent implements OnInit {

  @Output() layoutGraficoEvent: EventEmitter<String>;
  public tipoGrafico: String;

  constructor(private modalService: NgbModal) {
    this.layoutGraficoEvent = new EventEmitter<String>();
  }

  cadastrar(content) {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modalLayoutGrafico',
      size: 'lg'
    };
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
      this.tipoGrafico = result;
      this.layoutGraficoEvent.emit(this.tipoGrafico);
    }, (reason) => {
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/modal-layout-grafico/modal-layout-grafico.component.ts